module.exports = __webpack_public_path__ + "img/05_maska_pyatno_1.00dd108.svg";